import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import styles from "./ActionsRenderer.module.css";
import { ActionsRendererProps } from "./ActionsRenderer.utils";

/**
 * ActionsRenderer
 *
 * Renders an action button inside a grid row to initiate the client approval process.
 * - Button is conditionally enabled based on form and background check completion.
 * - Displays a tooltip for context.
 * - Triggers modal visibility and sets required IDs when clicked.
 */
const ActionsRenderer: React.FC<ActionsRendererProps> = ({
  data,
  setApprovalModalShow,
  setClientMasterId,
  setAttestFormId,
  setOnboardingFormId,
  setTaxAcceptanceFormId,
  setAuditAcceptanceFormId,
  setClientRecord,
  setFirmDetailId,
}) => {
  if (!data) return null;

  // Determine if approval button should be disabled based on statuses
  // console.log("Disable Approval: ", data.AcceptanceFormStatus.includes("Completed") && data.OnboardingFormStatus.includes("Completed"))
  const enableApprovalButton =
    data.OnboardingFormStatus.includes("Completed") || data.AttestFormStatus.includes("Completed");

  // Tooltip message depending on button state
  const approvalHoverMesage = enableApprovalButton
    ? "Start Approval Process"
    : "All requirements to start approval process are not completed.";

  return (
    <div className={styles.approvalButtonWrapper}>
      {/* Button with tooltip for starting approval */}
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip id="button-tooltip">{approvalHoverMesage}</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={styles.settingActionButton}
            onClick={() => {
              setClientMasterId(data.ClientMasterId || 0);
              setAttestFormId(data.AttestFormId);
              setOnboardingFormId(data.OnboardingFormId);
              setTaxAcceptanceFormId(data.TaxAcceptanceFormId);
              setAuditAcceptanceFormId(data.AuditAcceptanceFormId);
              setApprovalModalShow(true);
              setFirmDetailId(data.FirmDetailId);
              setClientRecord(data)
            }}
            disabled={!enableApprovalButton}
          >
            <Icon.CloudCheckFill />
          </Button>
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default ActionsRenderer;
